import { BaseApiService } from "@mirage/services/BaseApiService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IEnforcementNoticeFilteringLists } from "@shared/publicportal/contracts/EnforcementNoticeFilteringLists";
import { IEnforcementNoticeDetails } from "@shared/publicportal/contracts/IEnforcementNoticeDetails";
import { IENotice } from "@shared/publicportal/entities/IENotice";
import { IEnforcementService } from "@shared/publicportal/services/IEnforcementService";

export default class EnforcementNoticeService extends BaseApiService implements IEnforcementService {
    constructor() {
        super("publicportal/enforcementNotices");
    }
    async getFilteringLists(): Promise<IEnforcementNoticeFilteringLists> {
        const existingFilters = sessionStorage.getItem("publicportal.EnforcementNoticeService.dictionaries");
        if (!existingFilters) {
            const response = await this.httpInstance().get("/filters");
            const filters = response.data;
            sessionStorage.setItem("publicportal.EnforcementNoticeService.dictionaries", JSON.stringify(filters));
            return filters;
        }
        return JSON.parse(existingFilters);
    }
    async getEnforcements(): Promise<IENotice[]> {
        const response = await this.httpInstance().get("/");
        return response.data;
    }
    async getEnforcementById(enforcementId: number): Promise<IEnforcementNoticeDetails> {
        const response = await this.httpInstance().get(`/${enforcementId}`);
        return response.data;
    }
    async pageRequest(pageRequest: IEntityPageRequest): Promise<IEntityPageResult<IENotice>> {
        const response = await this.httpInstance().post("/pageRequest", pageRequest);
        return response.data;
    }
}
